import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-y-2 border-volt/25 bg-carbon" data-id="element-41" data-mp="1nv1l2blse3ze">
      <div className="mx-auto max-w-3xl px-3 py-8 sm:px-6 sm:py-10" data-id="element-42" data-mp="2bl5lka3ohnm6">
        <Reveal className="text-center" data-id="element-43" data-mp="2fkwa075qfrnj">
          <h2 id="faq" className="font-display text-xl uppercase leading-tight text-white sm:text-3xl lg:text-4xl" data-id="element-44" data-mp="2fo21tu5qx7my">
            Preguntas frecuentes
          </h2>
          <span aria-hidden="true" className="mx-auto mt-2 block h-1 w-14 rounded-full bg-volt" data-id="element-45" data-mp="26rjaunh2rtt0" />
        </Reveal>

        <div className="mt-4 grid gap-1.5" data-id="element-46" data-mp="2za6s1rsyaoot">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="rounded-lg border border-white/10 bg-night" data-id="element-47" data-mp="1vnoowo8wpfmy" data-mpi={i}>
                <h3 data-id="element-48" data-mp="25g45bh4k1w5q">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-3 text-left sm:px-4" data-id="element-49" data-mp="25gm7svht96m3">
                    <span className="text-[0.82rem] font-bold text-white sm:text-sm" data-id="element-50" data-mp="2ah0ady0n7ocq">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={17} className={`flex-shrink-0 text-volt transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-51" data-mp="2jgewkl9s1crf" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-52" data-mp="2p552eg86eyg3">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-53" data-mp="2u3q7asydi6av">
                      <p className="px-3 pb-3 text-[0.8rem] leading-snug text-steel sm:px-4 sm:text-sm" data-id="element-54" data-mp="3d0remkfegihz">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}